import type { HttpBadStatusCodeError, UnknownError } from '@cian/peperrors/shared';

import { EQueryKeys } from 'shared/store/serverSide/EQueryKeys';

export type QueryError = HttpBadStatusCodeError | UnknownError;

export type QueryKey = [EQueryKeys.GeoSuggest__V2_Suggest, string];
export const getQueryKey = (query: QueryKey[1]): QueryKey => [EQueryKeys.GeoSuggest__V2_Suggest, query];
